export default __webpack_public_path__ + "static/media/The Purpose-Driven Life_ What on Earth Am I Here For_ ( PDFDrive ).e4154644.pdf";